import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { LOCALS } from "../data/constants";
import { UK } from "./uk/uk.js";
import { CS } from "./cs/cs.js";
import { RU } from "./ru/ru.js";

const resources = {
    [LOCALS.UK]: {
        translation: UK,
    },
    [LOCALS.RU]: {
        translation: RU,
    },
    [LOCALS.CS]: {
        translation: CS,
    },
};

i18n.use(initReactI18next).init({
    resources,
    lng: "cs",
    fallbackLng: [LOCALS.UK],

    interpolation: {
        escapeValue: false,
    },
});
